import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Spinner = function Spinner(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Loading' : _ref$label,
      className = _ref.className;
  return _jsxs("div", {
    "aria-atomic": "true",
    role: "alert",
    "aria-live": "polite",
    children: [_jsx("div", {
      className: "sr-only",
      children: label
    }), _jsx("div", {
      className: "h-4 min-h-[1rem] w-4 min-w-[1rem] animate-spin rounded-full border-2 border-solid border-blue-200 border-t-primary ".concat(className)
    })]
  });
};